import { render, staticRenderFns } from "./editArticleDialog.vue?vue&type=template&id=23456fb2&"
import script from "./editArticleDialog.vue?vue&type=script&lang=js&"
export * from "./editArticleDialog.vue?vue&type=script&lang=js&"
import style0 from "./editArticleDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports